// TODO - Type 'any' needs to be fixed.
export const resetDeleteDraftShiftAsyncReducer = (state:any, action:any) => {
    state.deleteDraftShiftAsync.status = "idle";
    state.deleteDraftShiftAsync.errorMessage = "";
}